<template>
  <div>

    <div class="d-flex justify-space-between mb-5">
      <div>
        <div class="page-title mb-2">
          Requirement Form
        </div>
        <div class="d-flex align-center">
          <Iconify
              icon="bxs:message-square-detail"
              color="var(--theme-color-seven)"
              class="mr-3"
          ></Iconify>
          แบบฟอร์มความต้องการเทคโนโลยีที่ส่งยื่น
        </div>
      </div>

      <div class="d-flex flex-column gap-12">
        <div class="d-flex gap-12">
          <div class="flex-center" style="max-width: 190px">
            <div>สถานะ</div>
            <SelectBox
                placeholder="สถานะ"
                hide-details
            ></SelectBox>
          </div>

          <div style="max-width: 250px">
            <TextField
                hide-details
                placeholder="ค้นหา"
                append-inner-icon="search"
            ></TextField>
          </div>
        </div>

        <div class="d-flex justify-end">
          <Button
              @onClick="createForm"
          >
            สร้างแบบฟอร์ม
          </Button>
        </div>
      </div>
    </div>

    <div>
      <div class="d-flex justify-space-between table-head">
        <div
            v-for="(item, i) in tableHeader"
            :key="i"
            :style="{ 'width': item.width }"
        >
          {{ item.name }}
        </div>
      </div>

      <div class="list-layout">
        <RowCard
            v-for="(item, i) in requirementForms"
            :key="i"
            theme="2"
        >
          <v-btn small icon @click="onEdit(item.id)">
            <Iconify
                icon="material-symbols:edit"
                size="15px"
            ></Iconify>
          </v-btn>
          <v-btn small icon @click="goToRequirementPreview(item.id)">
            <Iconify
                icon="carbon:view-filled"
                size="15px"
            ></Iconify>
          </v-btn>
          <v-btn small icon @click="onDelete(item.id)">
            <Iconify
                style="color: #b1b1b1"
                icon="basil:trash-alt-solid"
                size="15px"
            ></Iconify>
          </v-btn>
          <div :style="{ 'width': tableHeader[1].width }">{{ i + 1 }}</div>
            <div :style="{ 'width': tableHeader[2].width }">{{ item.year }}</div>
            <div :style="{ 'width': tableHeader[3].width }">{{ item.doc_no }}</div>
            <div :style="{ 'width': tableHeader[4].width }">เเบบฟอร์มขอใช้บริการเทคโนโลยีสารสนเทศ</div>
            <div :style="{ 'width': tableHeader[5].width }">
              <div v-if="item.p1_last_name">
                {{ [item.p1_first_name, item.p1_last_name.slice(0, 1)].join('.') }}
              </div>
              <div v-else>
                {{ item.p1_first_name }}
              </div>
            </div>
            <div :style="{ 'width': tableHeader[6].width }">{{ item.doc_status }}</div>
        </RowCard>
      </div>
    </div>

  </div>
</template>

<script>
import TextField from "../../components/input/TextField"
import SelectBox from "../../components/input/SelectBox"
import Button from "../../components/input/Button"
import RowCard from "../../components/RowCard"

export default {
  name: "RequirementList",
  components: {
    TextField,
    SelectBox,
    Button,
    RowCard
  },
  data () {
    return {
      tableHeader: [
        {
          name: '',
          width: '6%'
        },
        {
          name: 'ลำดับ',
          width: '6%'
        },
        {
          name: 'ปี งปม.',
          width: '8%'
        },
        {
          name: 'เลขที่',
          width: '8%'
        },
        {
          name: 'เเบบฟอร์ม',
          width: '46%'
        },
        {
          name: 'ผู้นำเข้าข้อมูล',
          width: '13%'
        },
        {
          name: 'สถานะ',
          width: '13%'
        }
      ],
      requirementForms: [
        // {
        //   year: '2565',
        //   no: '2565',
        //   form: 'test form',
        //   importBy: 'non',
        //   status: 'แบบร่าง'
        // },
        // {
        //   year: '2565',
        //   no: '2565',
        //   form: 'test form',
        //   importBy: 'non',
        //   status: 'แบบร่าง'
        // },
        // {
        //   year: '2565',
        //   no: '2565',
        //   form: 'test form',
        //   importBy: 'non',
        //   status: 'แบบร่าง'
        // },
      ]
    }
  },
  created() {
    this.getAllForms()
  },
  methods: {
    async getAllForms () {
      let res = await this.$apiFire('Requirement/getRequirementForms')
      console.log(res)
      if (res) {
        this.requirementForms = res
      }
    },
    createForm () {
      this.$router.push({ name: 'RequirementForm' })
    },
    goToRequirementPreview(id) {
      this.$router.push({ path: `/requirement-preview/${id}` });
    },
    onEdit(id) {
      this.$router.push({ path: `/requirement-form/${id}` });
    },
    onDelete(id) {
      this.$emit("onDelete", id);
    },
  }
}
</script>

<style scoped lang="scss">
.table-head {
  padding: 0 33px 0 36px;
  margin-bottom: 12px;
  gap: 8px;
}

.list-layout {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
</style>